var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRealtimeData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "29px",
    viewBox: "0 0 34 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location_video_01",
    transform: "translate(-262.000000, -31.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3844450_cloud_computing_data_server_upload_icon",
    transform: "translate(263.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2537143,9.97052632 C25.8377143,4.3993985 21.3977143,0 16,0 C11.3828571,0 7.41942857,3.15669173 6.14057143,7.7606015 C2.49257143,9.09353383 0,12.7314286 0,16.8421053 C0,22.1485714 4.10171429,26.4661654 9.14285714,26.4661654 L24,26.4661654 C28.4114286,26.4661654 32,22.6887218 32,18.0451128 C32,14.2568421 29.6342857,11.0051128 26.2537143,9.97052632 Z",
    id: "XMLID_270_",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,9 C16.5522847,9 17,9.44771525 17,10 L17,18 L17,18 L15,18 L15,10 C15,9.44771525 15.4477153,9 16,9 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,16 L20,16 C20.5522847,16 21,16.4477153 21,17 C21,17.5522847 20.5522847,18 20,18 L17,18 L17,18 L17,16 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealtimeData);
export default __webpack_public_path__ + "static/media/realtime-data.1145a4f59188e56e817d4e883b3f43c0.svg";
export { ForwardRef as ReactComponent };